import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminThemeProvider } from "./admin/context/AdminThemeContext";

import { ToastContainer } from "react-toastify";
import { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";

/* ADMIN */
import ProtectedAdmin from "./admin/components/ProtectedAdmin";
import Layout from "./admin/components/Layout";
import Login from "./admin/pages/Login";
import Dashboard from "./admin/pages/Dashboard";
import DataList from "./admin/pages/DataList";
import AddData from "./admin/pages/AddData";
import AdminSettings from "./admin/pages/AdminSettings";
import AdminWinGo from "./admin/pages/AdminWinGo";
import AdminMinesGame from "./admin/pages/AdminMinesGame";
import AdminSpinWheel from "./admin/pages/AdminSpinWheel";

/* USER */
import UserLayout from "./userSide/components/UserLayout";
import UserHome from "./userSide/pages/UserHome";
import UserAuth from "./userSide/pages/UserAuth";
import Deposit from "./userSide/pages/Deposit";
import Withdraw from "./userSide/pages/Withdraw";
import History from "./userSide/pages/History";
import ProtectedUser from "./userSide/components/ProtectedUser";
import AviatorPage from "./userSide/aviator2/AviatorGame";

// GAMES
import AdminManageTitli from "./admin/pages/AdminManageTitli";
import AdminManageLucky7 from "./admin/pages/AdminManageLucky7";
import AdminManageMatka from "./admin/pages/AdminManageMatka";
import AdminManageMatkaList from "./admin/pages/AdminManageMatkaList";
import MatkaCalendar from "./userSide/games/MatkaCalendar";
import Lucky7 from "./userSide/games/Lucky7";
import Titli from "./userSide/games/Titli";
import MatkaGame from "./userSide/games/MatkaGame";
import MatkaList from "./userSide/games/MatkaList";
import AdminManageAviator from "./admin/pages/AdminManageAviator";
import ColorGame from "./userSide/games/wingo/ColorGame";
import MineGame from "./userSide/games/mines/MineGame";
import SpinWheel from "./userSide/games/spinwheel/SpinWheel";
import PaymentSettings from "./admin/pages/PaymentSettings";
import { useEffect } from "react";
import PendingDeposite from "./admin/pages/PendingDeposite";
import PendingWithdraw from "./admin/pages/PendingWithdraw";
import UsersList from "./admin/pages/UsersList";
import Reports from "./admin/pages/Reports";
import UserProfile from "./admin/pages/UserProfile";
import GameLoader from "./userSide/games/GameLoader";
import K3 from "./userSide/games/K3";
import AdminManageK3 from "./admin/pages/AdminManageK3";
import D5 from "./userSide/games/D5";
import AdminManage5d from "./admin/pages/AdminManage5d";
import UserHome2 from "./userSide/pages/UserHome2";
import UserAuth2 from "./userSide/pages/UserAuth2";
import Login2 from "./admin/pages/Login2";
import LudoGame from "./userSide/games/ludo/LudoGame";
import HeadTailGame from "./userSide/games/headtail/HeadTailGame";
import TeenPattiGame from "./userSide/games/teenpatti/TeenPattiGame";
import CallbackHistory from "./admin/pages/CallbackHistory";
import ChessGame from "./userSide/games/chess/ChessGame";

function App() {

  useEffect(() => {
    const updateActivity = () => {
      localStorage.setItem("loginTime", Date.now());
    };

    const checkSession = () => {
      const loginTime = Number(localStorage.getItem("loginTime"));
      const token = localStorage.getItem("token");

      if (!token || !loginTime) return;

      const diff = Date.now() - loginTime;

      if (diff > 15 * 60 * 1000) {
        localStorage.clear();
        // window.location.href = "/admin/login";
      }
    };

    // activity listeners
    window.addEventListener("mousemove", updateActivity);
    window.addEventListener("keydown", updateActivity);
    window.addEventListener("click", updateActivity);
    window.addEventListener("scroll", updateActivity);

    const interval = setInterval(checkSession, 5000);

    return () => {
      clearInterval(interval);

      window.removeEventListener("mousemove", updateActivity);
      window.removeEventListener("keydown", updateActivity);
      window.removeEventListener("click", updateActivity);
      window.removeEventListener("scroll", updateActivity);
    };
  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={2500} />
      <Toaster position="top-right" reverseOrder={false} />
      <BrowserRouter>
        <Routes>
          {/* ================= USER PUBLIC ================= */}
          <Route path="/gameLoader" element={<GameLoader />} />

          <Route path="/login" element={<UserAuth />} />

          <Route
            path="/"
            element={
              <UserLayout>
                <UserHome />
              </UserLayout>
            }
          />

          <Route path="/aviator" element={<AviatorPage />} />
          <Route path="/titli" element={<Titli />} />
          <Route path="/lucky7" element={<Lucky7 />} />
          <Route path="/k3" element={<K3 />} />
          <Route path="/5d" element={<D5 />} />
          <Route path="/matka/:market" element={<MatkaGame />} />
          <Route path="/matkalist" element={<MatkaList />} />
          <Route path="/matka/:marketId/calendar" element={<MatkaCalendar />} />
          <Route path="/mineGame" element={<MineGame />} />
          <Route path="/spinWheel" element={<SpinWheel />} />
          <Route path="/colorGame" element={<ColorGame />} />
          <Route path="/ludo" element={<LudoGame />} />
          <Route path="/chess" element={<ChessGame />} />
          <Route path="/headtail" element={<HeadTailGame />} />
          <Route path="/teenpatti" element={<TeenPattiGame />} />

          {/* ================= USER PROTECTED ================= */}
          <Route element={<ProtectedUser />}>
            <Route
              path="/deposit"
              element={
                <UserLayout>
                  <Deposit />
                </UserLayout>
              }
            />
            <Route
              path="/withdraw"
              element={
                <UserLayout>
                  <Withdraw />
                </UserLayout>
              }
            />
            <Route
              path="/history"
              element={
                <UserLayout>
                  <History />
                </UserLayout>
              }
            />
          </Route>

          {/* ================= ADMIN PUBLIC ================= */}
          <Route path="/admin" element={<Login />} />

          {/* ================= ADMIN PROTECTED ================= */}
          <Route element={<ProtectedAdmin />}>
            <Route
              path="/admin/dashboard"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManageAviator"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManageAviator />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManageTitli"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManageTitli />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManageLucky7"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManageLucky7 />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManageK3"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManageK3 />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManage5d"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManage5d />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManageMatka/:marketId"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManageMatka />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/adminManageMatkaList"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminManageMatkaList />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route path="/admin/wingo" 
            element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminWinGo />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route path="/admin/AdminSpinWheel" 
            element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminSpinWheel />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route path="/admin/minesGame" 
            element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminMinesGame />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/list"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <DataList />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/add"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AddData />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <AdminSettings />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/payment-settings"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <PaymentSettings />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/pendingDeposite"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <PendingDeposite />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/pendingWithdraw"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <PendingWithdraw />
                  </Layout>
                </AdminThemeProvider>
              }
            />
            
            <Route
              path="/admin/users"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <UsersList />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/user-profile/:phone"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <UserProfile />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/reports"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <Reports />
                  </Layout>
                </AdminThemeProvider>
              }
            />

            <Route
              path="/admin/api/reports"
              element={
                <AdminThemeProvider>
                  <Layout>
                    <CallbackHistory />
                  </Layout>
                </AdminThemeProvider>
              }
            />

          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
